import {
  FAQS,
  PRE_PURCHASE_FAQS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import logoImage from "public/images/pdxtimbers/portland-timbers-logo.png";

const OrderSummaryBackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/MLS/Portland%20Timbers/2025_BreakawayMembership_1920x1080_BackgroundImages.png";

export const pdxtimbers_pass: TTeamConfig = {
  TEAM_SCHEMA: "pdxtimbers_pass",
  TEAM_FULL_NAME: "Portland Timbers",
  BROWSER_TITLE: "Timbers Breakaway Pass",
  CLIENT_ID: "NDYxNzQ3MTB8MTc0NDIzMzYwNS45ODI5NDEy",
  VENDOR: constants.vendorUUIDs.seatgeek,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#00482B",
    COLORS_SECONDARY: "#d69a00",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
      SHOW_FAQ_BUTTON: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: logoImage.src,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage,
  },

  LANGUAGES: {
    FAQS,
    PRE_PURCHASE_FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
